import React, { Component } from 'react';
import './CriteriaTabs.css';
import _ from 'lodash';
import uuidv1 from 'uuid/v1';

class CriteriaTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }

    componentWillMount(){
        if(!_.isEmpty(this.props.attractivenessData)){
            this.setState({
                data:this.props.attractivenessData
            })
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.attractivenessData &&  nextProps.addedNewItemState ){
            this.props.addedNewItem(false)
            this.setState({
                data:nextProps.attractivenessData
            })
        }
    }

    onChangeValue = (value) => {
        const uuidv1 = require('uuid/v1');
        let newValue = {
            important: false,
            name: value,
            criteriaId: uuidv1()
        }
        this.setState({
            newValue: newValue
        })
    }

    onNewValueAdd = (key, newValue, groupId) => {
        if (this.state.newValue) {
            let input = document.getElementsByClassName("valuesinput");
            for(let i in input){
                if(input[i].value){
                    input[i].value=""
                }
            }
            let data = this.state.data
            this.props.onNewValueAdd(newValue, groupId)
        }
    }

    onValueCheckBoxSelect=(e, id) =>{
        let data = this.state.data;
        let item = this.state.data.find(r => r.attractivnessId === id);
        item.important = e.target.checked;

        this.setState({
            data: data
        },()=>this.props.onValueCheckBoxSelect(item.important, id)
        )
        // debugger
    }

    onValueDelete = (key,index) => {
        let updatedData = [];
        for (let item of this.state.data){
            item.attractivnessId !==  index.attractivnessId  && updatedData.push(item) ;
        }
        this.setState({
            data: updatedData
        },()=>this.props.onValueDelete(index)
        )
    }

    onDeleteTab = (id) => {
        let updatedData = [];
        for (let item of this.state.data){
            item.groupId !== id  && updatedData.push(item) ;
        }
        this.setState({
            data: updatedData
        },()=>this.props.onDeleteTab(id)
        )
    }

    render() {

        let tabs = this.props.tabs.map((item,key) => {

            return (
                <li className="nav-item" key={item.groupName} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key ===  this.props.tabStep ? "nav-link active show" :"nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="true">{item.groupName}
                    {/* <i className="fa fa-minus minus-icon" onClick={() => this.onDeleteTab(item.groupId)}></i> */}
                </a>
            </li>)
        });

        let tabsContent = this.props.tabs.map((item, key) => {
            const groupName = this.props.tabs.find(r => r.groupId === item.groupId).groupName;
            return(
                <div id={groupName} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv": "tab-pane fade tabContentdiv"} role="tabpanel" key={key}>
                    <div className="row">
                      <div className='col-sm-12'>
                        <p><i>Check the box of the 4-6 most important criteria.</i></p>
                      </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5">
                            <div className="form-group create-name-box">
                                <input type="text" className="tabContentInput valuesinput form-control" onChange={(e) => this.onChangeValue(e.target.value)} onKeyPress={(e)=>{ e.key == 'Enter' && this.onNewValueAdd(key, this.state.newValue, item.groupId)}} placeholder="Name Your Criteria" />
                                <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onNewValueAdd(key, this.state.newValue, item.groupId)}></i>
                            </div>
                            {this.state.data && !_.isEmpty(this.state.data) && this.state.data.map((i,index )=> {
                                if( i.groupId === item.groupId ){
                                    return <div className="addedValues" key={index}>
                                        <label>{i.name}</label>
                                        <div>
                                            <input type="checkbox" checked={i.important} onChange={(e)=>this.onValueCheckBoxSelect(e, i.attractivnessId, key)} />
                                            <i className="fa fa-minus minus-icon" onClick={()=>this.onValueDelete(key,i)}></i>
                                        </div>
                                    </div>
                                }

                            })}
                        </div>
                    </div>
                </div>
            )
        })

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {/* <li className="nav-item">
                        <a  id='plusTab' onClick={() => this.props.createCriterial()}
                        ><i className="fa fa-plus plusbtn plus-icon"></i></a>
                    </li> */}
                    {tabs}
                    {/* { !_.isEmpty(this.props.attractivnessData.Items) && this.addTabs(this.props.attractivnessData.Items[0].data)} */}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}
export default (CriteriaTabs);



// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/Criteria/CriteriaTabs/CriteriaTabs.jsx